module.exports = __webpack_public_path__ + "img/operator-manageent.fb89cd8a.svg";